import { css } from "@emotion/react";
import { IconsAndTextsType } from "@swo/storefront";
import React from "react";
import { ContentContainer } from "../../../components/_shared-components/arrangement/Container";
import { Spacer } from "../../../components/_shared-components/arrangement/Space";
import { CSS_SPACER_SIZES } from "../../../styles/styles-css-variables";
import { PDPHeadlineOnBackground } from "../pdp-headline";
import { ConsiderOption } from "./ConsiderOption/ConsiderOption";
import { IconsAndTextComponentBottomRow } from "./IconsAndTextComponentBottomRow";
import { CardsCarousel } from "./CardsCarousel/CardsCarousel";
import { nonEmpty } from "@swo/shared";

export const IconsAndTextsPdpComponent: React.FC<IconsAndTextsType> = props => {
  return (
    <>
      <Spacer size={"md"} />

      <div
        className="js-icons-and-text-pdp-component"
        css={css`
          background-color: var(--so-green-white);
          padding: ${CSS_SPACER_SIZES.md} 0px 16px;

          overflow-x: hidden;
        `}
      >
        <ContentContainer width={"narrow"}>
          <PDPHeadlineOnBackground>{props.headline}</PDPHeadlineOnBackground>

          <CardsCarousel
            items={props.items}
            Component={ConsiderOption}
            findText={_ => [_.text].filter(nonEmpty)}
            getKey={_ => JSON.stringify(_)}
            theme={"light-background"}
          />

          {props.bottomText && props.callToAction && (
            <IconsAndTextComponentBottomRow bottomText={props.bottomText} callToAction={props.callToAction} />
          )}
        </ContentContainer>
      </div>
    </>
  );
};
